import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { ScopeChangeRequestResolveDialog } from '@/features/admin/scope-change-requests/ScopeChangeRequestResolveDialog'
import { type ScopeChangeRequestResolveDialogViewModel } from './ScopeChangeRequestResolveDialogViewModel'

export interface ScopeChangeRequestResolveDialogContainerProps {
  vm: ScopeChangeRequestResolveDialogViewModel
}

export const ScopeChangeRequestResolveDialogContainer = observer(
  function ScopeChangeRequestResolveDialogContainer({
    vm,
  }: ScopeChangeRequestResolveDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))
    return (
      <ScopeChangeRequestResolveDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        corporateMode={shellInfo.corporateMode}
        clientName={vm.scopeChangeRequest.jobClient?.member.displayName}
        resolveAction={vm.resolveAction}
        onActionChange={vm.setAction}
        isJobClosed={vm.isJobClosed}
        onResolve={vm.resolve}
        isResolvePending={vm.resolve.pending}
      />
    )
  },
)
